module.exports = __webpack_public_path__ + "img/Rogue.b0b3c6db.png";